import { render } from "./WaterMeasurements.vue?vue&type=template&id=4164dd96&scoped=true"
const script = {}

import "./WaterMeasurements.vue?vue&type=style&index=0&id=4164dd96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4164dd96"

export default script